import { $Q } from './query-selector';

/**
 * Update the class of steps in bar progress
 * @param {HTMLElement} steps - array of spans
 * @param {Number} barWidth - percent complete of bar progress
 */
const stepProgress = (steps, barWidth) => {
  const stepRange = steps ? 100 / (steps.length + 1) : 0;
  steps.forEach((item, index) => {
    if ((index + 1) * stepRange < barWidth) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
};

/**
 * Update the width of bar progress
 * @param {HTMLElement} input - input hidde with data
 */
export const barProgress = (input) => {
  let totalPrice = 0;
  let limitPrice = 10;
  if (input) {
    totalPrice = parseFloat(input.dataset.total) / 100;
    limitPrice = input.dataset.limit;
  }
  const progress = $Q('.bar-progress');
  const elementTotal = $Q('.total-residuary');

  const textProgress = $Q('.progress-text-js');
  const textFreeShipping = $Q('.shipping-free');
  // Validate if Cart is empty
  if (progress) {
    const barWidth = (totalPrice / limitPrice) * 100;
    const residuaryPrice = limitPrice - totalPrice;

    // Validate what step is active
    stepProgress(document.querySelectorAll('.step'), barWidth);

    if (barWidth > 100) {
      progress.style.width = '100%';
      textProgress.style.display = 'none';
      textFreeShipping.style.display = 'block';
    } else {
      progress.style.width = `${barWidth}%`;
      elementTotal.innerHTML = `${residuaryPrice.toFixed()}€`;
      textProgress.style.display = 'block';
      textFreeShipping.style.display = 'none';
    }
  }
};
